import type { BeneficiaryTypeGrantsPayload } from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsFetched';

export type BeneficiaryTypeGrantsSavedAction = {
	type: 'BENEFICIARY_TYPE_GRANTS_SAVED';
	payload: BeneficiaryTypeGrantsPayload;
	accountId: number;
};

export default (
	payload: BeneficiaryTypeGrantsPayload,
	accountId: number,
): BeneficiaryTypeGrantsSavedAction => ({
	type: 'BENEFICIARY_TYPE_GRANTS_SAVED',
	payload,
	accountId,
});
